import { Toast as HeroToast } from '@heroui/react';
import type { ReactNode } from 'react';
import { useCallback, useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import Toast from '@/shared/components/Toast';

type Props = {
  readonly children: ReactNode;
};

const ToastProvider = ({ children }: Props) => {
  const { toast, setToast } = useContext(PageContext);

  const hideToast = useCallback(() => {
    setToast('');
  }, [setToast]);

  return (
    <>
      {children}
      <HeroToast.Provider placement="top" width="min(420px, calc(100vw - 32px))">
        {({ toast: queuedToast }) => {
          const { title, variant } = queuedToast.content;
          const isDanger = variant === 'danger';

          return (
            <HeroToast toast={queuedToast} variant={variant}>
              <HeroToast.Indicator variant={variant} />
              {/* React Aria makes every toast `role="alert"`; only errors should interrupt. */}
              <HeroToast.Content
                role={isDanger ? 'alert' : 'status'}
                aria-live={isDanger ? 'assertive' : 'polite'}
                className="min-w-0"
              >
                {/* Messages can carry an unbroken email or URL. */}
                <HeroToast.Title className="wrap-anywhere">{title}</HeroToast.Title>
              </HeroToast.Content>
              <HeroToast.CloseButton />
            </HeroToast>
          );
        }}
      </HeroToast.Provider>
      <Toast message={toast.message} variant={toast.variant} callback={hideToast} />
    </>
  );
};

export default ToastProvider;
